/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { Stack } from '@mui/material'
import { OIDC_CONFIG_UNION } from '../constants'
import { Layout, ThirdPartyButtons } from '../components'
import EmailLogin from './emailLogin'
import { Button, Link, Message, DownloadApp, Typography, useDocumentTitle } from '@prom/web-embers'
import { parseUrl } from '../utils/formValidation'
import { isFromApp, isFromExpired } from '../utils/urlUtils'
import { isMobile } from '../utils/platformUtils'
import tracker, { AccountMethod } from '../services/mixpanelService'

export const Login = () => {
  const intl = useIntl()
  const [emailLoginView, setEmailLoginView] = useState(
    !!OIDC_CONFIG_UNION.ERROR || OIDC_CONFIG_UNION.LOGIN === 'email' || OIDC_CONFIG_UNION.LOGIN === 'imported',
  )
  const [loginError, setLoginError] = useState(OIDC_CONFIG_UNION.ERROR)

  useDocumentTitle(intl.formatMessage({ id: 'pageTitle.signInToPromethean' }))

  const toggleLoginView = () => {
    !emailLoginView && tracker.signInStart(AccountMethod.EMAIL)
    loginError && setLoginError('')
    setEmailLoginView(!emailLoginView)
  }

  return emailLoginView ? (
    <EmailLogin error={loginError} />
  ) : (
    <Layout
      className="Login-root"
      cardProps={{
        title: intl.formatMessage({ id: 'signInNormal', defaultMessage: 'Sign in' }),
        subtitle: (
          <Typography variant="small" align="center">
            {intl.formatMessage({
              id: 'login.schoolAccount',
            })}
          </Typography>
        ),
        feedbackMessage: isFromExpired(window.location.search) && (
          <Stack marginBottom={4}>
            <Message type="alert">
              {intl.formatMessage({
                id: 'error.login.expired',
              })}
            </Message>
          </Stack>
        ),
        children: (
          <Stack marginLeft={17 / 8} marginRight={17 / 8}>
            <ThirdPartyButtons type="login" providers={OIDC_CONFIG_UNION.PROVIDERS || []} />
            <Button
              level="secondary"
              drawingStyle="outlined"
              colorTheme="grey"
              size="large"
              fullWidth
              onClick={toggleLoginView}
              startIcon={<span className="icon-email" role="img" aria-hidden="true" />}
            >
              <span>{intl.formatMessage({ id: 'login.email' })}</span>
            </Button>
            <i className="divider" />
            <Stack display="flex" alignItems="center">
              <Link onClick={() => window.location.assign(parseUrl(OIDC_CONFIG_UNION.REGISTER_LINK))} role="link">
                {intl.formatMessage({ id: 'login.needAccount' })}
              </Link>
            </Stack>
            {!isFromApp(window.location.search) && isMobile() && (
              <Stack marginTop={5}>
                <DownloadApp mixpanelProps={{ tracker, pageView: 'sign in' }} />
              </Stack>
            )}
          </Stack>
        ),
      }}
    />
  )
}

export default Login
